module.exports = __webpack_public_path__ + "static/img/11.7642e7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/11.png
// module id = S8ne
// module chunks = 0